import { DashboardSeriesItem } from 'shared/api';

export const toDashboardChartKey = (metric: string) => metric.replace(/\./g, '_');

export const buildDashboardChartAxis = (from?: string, to?: string) => {
	if (!from || !to) {
		return [];
	}

	const start = new Date(`${from.slice(0, 10)}T00:00:00.000Z`);
	const end = new Date(`${to.slice(0, 10)}T00:00:00.000Z`);

	if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) || start > end) {
		return [];
	}

	const rows: { date: string }[] = [];

	for (let cursor = start; cursor <= end; cursor.setUTCDate(cursor.getUTCDate() + 1)) {
		rows.push({ date: cursor.toISOString().slice(0, 10) });
	}

	return rows;
};

export const buildDashboardChartData = (series: DashboardSeriesItem[]) => {
	const rows = new Map<string, Record<string, string | number>>();

	series.forEach((item) => {
		item.points.forEach((point) => {
			const date = point.bucket.slice(0, 10);
			const row = rows.get(date) ?? { date };

			row[toDashboardChartKey(item.metric)] = point.value;
			rows.set(date, row);
		});
	});

	return [...rows.values()].sort((left, right) =>
		String(left.date).localeCompare(String(right.date)),
	);
};
